var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import template from 'text!./accounts-table.html';
import assert from 'assert';

export default ['$filter', function ($filter) {
    return {
        restrict: 'EA',
        template: template,
        scope: {
            accounts: '=',
            noResultsMessage: '@',
            pageData: '@',
            pageSize: '@',
            loadByOffset: '&'
        },
        link: function link($scope, $element) {
            $scope.orderByDescending = true;
            $scope.dynamicSort = function () {
                $scope.pageData = angular.fromJson($scope.pageData);
                return $scope.accounts && $scope.accounts.length > 0 && $scope.pageData.maxNumberOfResults > $scope.pageSize;
            };
            $scope.reloadSortData = function (sortColumn) {
                if ($scope.dynamicSort() == false) {
                    $scope.orderByDescending = !$scope.orderByDescending;
                    if (sortColumn === 'AccountName') {
                        $scope.accounts = $filter('orderBy')($scope.accounts, 'account', $scope.orderByDescending);
                    } else {
                        $scope.accounts = $filter('orderBy')($scope.accounts, 'createdDate', $scope.orderByDescending);
                    }
                    return;
                }
                $scope.loading = true;
                $scope.pageData = angular.fromJson($scope.pageData);
                if ($scope.pageData.displayStart !== '' && $scope.pageData.displayEnd !== '') {
                    $scope.loadByOffset()($scope.pageData.displayStart - 1, $scope.pageData.displayEnd - 1, true, sortColumn).then(function (data) {
                        assert((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && typeof data.maxNumberOfResults === 'number', 'Expecting a response with maxNumberOfResults key. ' + 'It will be available as pageListData in the transcluded scope.');
                        $scope.accounts = data.items;
                    }).catch(function () {
                        $scope.error = true;
                    });
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/AccountsTableDirective/accounts-table.directive.js
// module id = 1723
// module chunks = 0